export const FORM_LIST_REQUEST = 'FORM_LIST_REQUEST';
export const FORM_LIST_SUCCESS = 'FORM_LIST_SUCCESS';
export const FORM_LIST_FAIL = 'FORM_LIST_FAIL';

export const FORM_DETAILS_REQUEST = 'FORM_DETAILS_REQUEST';
export const FORM_DETAILS_SUCCESS = 'FORM_DETAILS_SUCCESS';
export const FORM_DETAILS_FAIL = 'FORM_DETAILS_FAIL';
export const FORM_DETAILS_RESET = 'FORM_DETAILS_RESET';

export const FORM_CREATE_REQUEST = 'FORM_CREATE_REQUEST';
export const FORM_CREATE_SUCCESS = 'FORM_CREATE_SUCCESS';
export const FORM_CREATE_FAIL = 'FORM_CREATE_FAIL';
export const FORM_CREATE_RESET = 'FORM_CREATE_RESET';

export const FORM_UPDATE_REQUEST = 'FORM_UPDATE_REQUEST';
export const FORM_UPDATE_SUCCESS = 'FORM_UPDATE_SUCCESS';
export const FORM_UPDATE_FAIL = 'FORM_UPDATE_FAIL';
export const FORM_UPDATE_RESET = 'FORM_UPDATE_RESET';

export const FORM_DELETE_REQUEST = 'FORM_DELETE_REQUEST';
export const FORM_DELETE_SUCCESS = 'FORM_DELETE_SUCCESS';
export const FORM_DELETE_FAIL = 'FORM_DELETE_FAIL';


export const FORM_DTO_REQUEST = 'FORM_DTO_REQUEST';
export const FORM_DTO_SUCCESS = 'FORM_DTO_SUCCESS';
export const FORM_DTO_FAIL = 'FORM_DTO_FAIL';
export const FORM_DTO_RESET = 'FORM_DTO_RESET';

export const FORM_LIST_BYIDS_REQUEST = 'FORM_LIST_BYIDS_REQUEST';
export const FORM_LIST_BYIDS_SUCCESS = 'FORM_LIST_BYIDS_SUCCESS';
export const FORM_LIST_BYIDS_FAIL = 'FORM_LIST_BYIDS_FAIL';
export const FORM_LIST_BYIDS_RESET = 'FORM_LIST_BYIDS_RESET';

export const FORM_LIST_RESET = 'FORM_LIST_RESET';

